// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader_container__MKwDV","title":"ModalHeader_title__NrMXx"};